import { render, staticRenderFns } from "./FullscreenLoading.vue?vue&type=template&id=12d2e959&scoped=true"
import script from "./FullscreenLoading.vue?vue&type=script&setup=true&lang=js"
export * from "./FullscreenLoading.vue?vue&type=script&setup=true&lang=js"
import style0 from "./FullscreenLoading.vue?vue&type=style&index=0&id=12d2e959&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12d2e959",
  null
  
)

export default component.exports